import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSolidCheckmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 11,
	viewBox: "0 0 12 11",
	width: 12,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M11.659.747a1 1 0 0 1 .094 1.412l-7 8A1 1 0 0 1 3.2 10.1l-3-4a1 1 0 0 1 1.6-1.2l2.26 3.013L10.248.842a1 1 0 0 1 1.41-.095z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgSolidCheckmin);
export { ForwardRef as ReactComponent };
